import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ClickOnTheMapContainer, ClickOnTheMapIcon, ClickOnTheMapLabel } from "./styled";
import clickOnMap from "../../../../assets/icons/tap.svg";
export const ClickOnTheMap = () => {
    return (_jsxs(ClickOnTheMapContainer, { children: [_jsx(ClickOnTheMapIcon, { src: clickOnMap }), _jsx(ClickOnTheMapLabel, { children: "Click on the map" })] }));
};
